import { isAxiosError } from 'axios';

// The request was made but no response ever arrived.
export const isNetworkError = (err: unknown): boolean =>
  isAxiosError(err) && !err.response && Boolean(err.request);
